import React, { Component } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom';
import {Helmet} from "react-helmet";
import Header from '../container/Header';
import Footer from '../container/Footer';
import Navmenu from '../component/Navmenu';
import Content from '../container/Content';
import CategoryList from '../container/CategoryList';
import ProductList from '../container/ProductList';
import ProductDetails from '../component/ProductDetails';
import Brands from '../container/Brand';
import About from '../container/About';
import Contact from '../container/Contact';
import NotFound from '../container/NotFound';

var PRODUCTS = [
  { name: "化氣爐" },
  { name: "氣體控制設備" },
  { name: "調壓器" },
  { name: "流量計" },
  { name: "熱水爐" },
  { name: "壓縮機" },
  { name: "液位計" },
  { name: "閥門" },
  { name: "高壓軟管" },
  { name: "自動交換器" },
  { name: "防爆形氣體感應器" },
  { name: "水泵" },
  { name: "磁力化學泵" },
  { name: "球閥" },
  { name: "其他配件" },
  { name: "穩壓器" }
]

const brStyle = {
  minHeight: '800px',
  padding: '400 0 500 0'
};

const tranlationTexts = {
  //homepage
  FeaturedProducts : { en: "Featured Products", chi: "熱門品牌"},
  GreatProducts : { en: "Great products, great value!", chi: ""},
  Brands : { en: "Brands", chi: "品牌"},

  // footer
  Preseli : { en: "Preseli ", chi: "百事利" },
  EngSupply : { en: "Engineering Supplies Ltd", chi: "器材有限公司" },
  AddressLine1 : { en: "Flat 11, 8/F, Profit Industrial Building,", chi: "葵芳葵豐街一至十五號" },
  AddressLine2 : { en: "1-15, Kwai Fung Crescent, Kwai Fong, N.T., Hong Kong", chi: "盈業工廠大厦8樓11室" },
  Copyright : { en: "Copyright", chi: "版權所有" },
//placeholder="輸入品牌或產品名稱，搜尋全場 165,275 件商品"
  //contact us
  Contact : { en: "Contact", chi: "聯繫" },
  Us: { en: "Us", chi: "我們" },
  WaysToGetInTouch : { en: "Ways To Get In Touch", chi: "聯繫方法" },
  Name: { en: "Name", chi: "稱呼" },
  Company: { en: "Company", chi: "公司" },
  Email: { en: "Email", chi: "聯絡電郵地址" },
  TellUs: { en: "Tell us what you want to know", chi: "留言" },
  SendMessage: { en: "Send Message", chi: "提交" },

  //products
  ProductCollection : { en: "Collections", chi: "器材分類"},
  Keyword : { en: "Keyword", chi: "搜尋"},
  ViewProductDetails : { en: "View Product Details", chi: "查看"},
  NoProductToBeDisplayed : { en: "Sorry, there is no product to be displayed...", chi: "對不起，沒有相關的產品..."},
  Loading : { en: "Loading...", chi: "載入中..."},
  All : { en: "All", chi: "任何分類"},

  //product details page
  Back : { en: "Go back", chi: "上一頁"},
  ProductDescription : { en: "Product Description", chi: "器材簡介"},
  Details : { en: "Details", chi: "器材簡介"},
  Attachment : { en: "Attachment", chi: "附件"},
  RelatedProducts : { en: "Related Products", chi: "相關產品"},
  ShowingProducts : { en: "showing product:", chi: "顯示產品"},
  InvalidLink : { en: "Sorry, this link seems to be broken... Please go back and try another product", chi: "對不起，沒有相關的產品...請回上一頁去嘗試其他產品"},
  
}



export function chunks(arr, size) {
  if (!Array.isArray(arr)) {
    throw new TypeError('Input should be Array');
  }

  if (typeof size !== 'number') {
    throw new TypeError('Size should be a Number');
  }

  var result = [];
  for (var i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, size + i));
  }

  return result;
};

var ReactGA = require('react-ga');
ReactGA.initialize('UA-102609168-1', {
  'cookieDomain': 'none'
});

function logPageView() {
  // console.log("logPageView : " + window.location.pathname)
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}

const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }}/>
  );
}

const Main = ({language, getTranslatedText}) => (
  <Switch>
    <PropsRoute exact path='/' component={Content} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute path='/categories' component={CategoryList} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute exact path='/products' component={ProductList} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute path='/products/:category/:brand' component={ProductList} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute path='/product/:productId?' component={ProductDetails} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute exact path='/brands' component={Brands} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute path='/about' component={About} language={language} getTranslatedText={getTranslatedText}/>
    <PropsRoute path='/contact' component={Contact} language={language} getTranslatedText={getTranslatedText}/>
    <Route path='/attachment'/>
    <Route path='/img'/>
    <Route path='*' component={NotFound} />
  </Switch>
)

class App extends React.Component {

  constructor(props){
    super(props);
    this.state = {
        language: "en"
    };

    this.handleUpdateLanguage = this.handleUpdateLanguage.bind(this);
    this.getTranslatedText = this.getTranslatedText.bind(this);

  }

  componentWillReceiveProps() {
    logPageView();
  }

  componentDidUpdate() {
    ReactDOM.findDOMNode(this).scrollIntoView();
  }

  handleUpdateLanguage(lang) {
    console.log("handleUpdateLanguage")
    if(this.state.language != lang) {
      this.setState({
        language: lang
      })
    }
  }

  getTranslatedText(text){
    if(tranlationTexts[text] == undefined || tranlationTexts[text][this.state.language] == undefined) {
      return "CANNOT FIND TEXT: " + text;
    } else {
      return tranlationTexts[text][this.state.language];
    }
  }

  render() {
    return (
      <div>
        <Helmet>
            <title>{'Preseli Engineering Supplies'}</title>
            <meta name="description" content={'Preseli Engineering Supplies. Specialised in selling Gas equipment, Water and Air Conditioning equipment'}/>
            <meta name="keywords" content={'Vaporizer, Burner Controls, Regulator, Gas Flow Meter, Water Heater, Gas Compressor, Level Gauge, Valve,Rubber Hose, Automatic Change Over, Gas Detector, Water PumpMagnetic Chemical Pump, Ball Valve, Miscellaneous, Governor'}/>
        </Helmet>

        {/*======== @Region: body ========*/}
        <div className="page page-shop header-compact-sticky page-shop navbar-layout-navbar-below">
          {/*<!-- @plugin: page loading indicator, delete to remove loader -->*/}
          {/*<div className="page-loader" data-toggle="page-loader"></div>*/}

          <a id="#top" href="#content" className="sr-only">Skip to content</a>

          {/*<!-- ======== @Region: #header ======== -->*/}
          <div id="header">

            <div data-toggle="sticky">

              {/*<!--Header search region - hidden by default -->*/}
              <div className="header-search collapse" id="search">
                <form className="search-form container">
                  <input type="text" name="search" className="form-control search" value="" placeholder="Search" />
                  <button type="button" className="btn btn-link"><span className="sr-only">Search </span><i className="fa fa-search fa-flip-horizontal search-icon"></i></button>
                  <button type="button" className="btn btn-link close-btn" data-toggle="search-form-close"><span className="sr-only">Close </span><i className="fa fa-times search-icon"></i></button>
                </form>
              </div>

              {/*<!--Header & Branding region-->*/}
              <Header handleUpdateLanguage={this.handleUpdateLanguage} language={this.state.language} getTranslatedText={this.getTranslatedText}/>

              <Navmenu products={PRODUCTS} language={this.state.language}/>
            </div>
          </div>
        </div>
        <Main style={brStyle} language={this.state.language} getTranslatedText={this.getTranslatedText}/>
        <Footer products={PRODUCTS} language={this.state.language} getTranslatedText={this.getTranslatedText}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/App.js